(function () {
  'use strict';
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  window.__err = [];
  addEventListener('error', e => window.__err.push((e.message || '?') + ' @' + (e.filename || '') + ':' + e.lineno));
  addEventListener('unhandledrejection', e => window.__err.push('rejection: ' + (e.reason && e.reason.message || e.reason)));
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const easeIO = t => t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  const easeO = t => 1 - Math.pow(1 - t, 3);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  let vw = innerWidth, vh = innerHeight;
  const isMobile = () => vw < 861;

  /* ================= smooth scroll ================= */
  let lenis = null;
  if (window.Lenis && !reduced) {
    lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    const raf = t => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    window.__lenis = lenis;
  }
  $$('[data-scroll]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (!id || !id.startsWith('#')) return;
      e.preventDefault();
      if (id === '#top') { lenis ? lenis.scrollTo(0) : scrollTo(0, 0); return; }
      const el = $(id);
      if (el) lenis ? lenis.scrollTo(el, { offset: 0 }) : el.scrollIntoView();
    });
  });

  /* ================= assets ================= */
  // story frame sequence : noise -> clear
  const FRAME_N = 100;
  const storyFrames = new Array(FRAME_N).fill(null);
  /* SP: 中央クロップ+再圧縮した軽量セット(frames-sp, 約2.1MB)。PCフルセットは約7.7MB */
  const ASSET_BASE = window.TG_ASSET_BASE || 'assets/';
  const FRAME_DIR = matchMedia('(max-width: 860px)').matches ? ASSET_BASE + 'tg-frame-sp-' : ASSET_BASE + 'tg-frame-pc-';
  const frameSrc = i => FRAME_DIR + String(i + 1).padStart(4, '0') + '.webp';
  const COARSE = [];
  for (let i = 0; i < FRAME_N; i += 20) COARSE.push(i);
  COARSE.push(FRAME_N - 1);

  let loaderTarget = 0, siteReady = false;

  function loadImg(src) {
    return new Promise(res => {
      const img = new Image();
      img.onload = () => res(img);
      img.onerror = () => res(null);
      img.src = src;
    });
  }

  function loadRestFrames() {
    // SP: FV動画のDLと帯域を奪い合わないよう並列数を絞る
    const MAX_INFLIGHT = matchMedia('(max-width: 860px)').matches ? 2 : 4;
    let i = 0, inFlight = 0;
    (function next() {
      while (inFlight < MAX_INFLIGHT && i < FRAME_N) {
        const idx = i++;
        if (storyFrames[idx]) continue;
        inFlight++;
        loadImg(frameSrc(idx)).then(img => {
          if (img) storyFrames[idx] = img;
          inFlight--; next();
        });
      }
    })();
  }

  async function loadAssets() {
    const jobs = [];
    COARSE.forEach(idx => jobs.push(loadImg(frameSrc(idx)).then(img => { if (img) storyFrames[idx] = img; })));
    const total = jobs.length;
    let done = 0;
    await Promise.all(jobs.map(j => j.then(() => { done++; loaderTarget = done / total; })));
    siteReady = true;
    // 残りフレームはFV再生とファーストビュー描画を優先してから流す
    const idle = window.requestIdleCallback || (fn => setTimeout(fn, 800));
    idle(() => loadRestFrames());
  }
  loadAssets();

  /* ================= loader ================= */
  const loader = $('#loader'), lPct = $('#l-pct'), lFill = $('#l-fill');
  let loaderVal = 0, loaderDone = false;
  requestAnimationFrame(() => loader.classList.add('ready'));

  function loaderStep() {
    if (loaderDone) return;
    loaderVal = lerp(loaderVal, loaderTarget, siteReady ? 0.35 : 0.14);
    if (siteReady && loaderVal > 0.992) loaderVal = 1;
    lPct.textContent = String(Math.round(loaderVal * 100)).padStart(3, '0');
    lFill.style.transform = `scaleX(${loaderVal})`;
    if (loaderVal >= 1) {
      loaderDone = true;
      setTimeout(() => {
        loader.classList.add('done');
        document.body.classList.remove('is-locked');
        document.body.classList.add('is-ready');
      }, 350);
    }
  }
  // drive by rAF for smoothness, and by interval so throttled tabs still finish
  (function tick() { if (loaderDone) return; loaderStep(); requestAnimationFrame(tick); })();
  const loaderIv = setInterval(() => { loaderStep(); if (loaderDone) clearInterval(loaderIv); }, 150);
  setTimeout(() => { siteReady = true; loaderTarget = 1; }, 4000); // hard cap(未着フレームはnearestFrameが補完)

  /* ================= grain ================= */
  const grain = $('#grain'), gtx = grain.getContext('2d');
  const gTiles = [];
  (function makeGrain() {
    for (let t = 0; t < 3; t++) {
      const c = document.createElement('canvas'); c.width = c.height = 224;
      const x = c.getContext('2d'), d = x.createImageData(224, 224);
      for (let i = 0; i < d.data.length; i += 4) {
        const v = 235 + Math.random() * 20 | 0;
        d.data[i] = d.data[i + 1] = d.data[i + 2] = v;
        d.data[i + 3] = Math.random() < 0.5 ? 22 : 0;
      }
      x.putImageData(d, 0, 0);
      gTiles.push(c);
    }
  })();
  let gFrame = 0, gLast = 0;
  function drawGrain(now) {
    if (reduced) return;
    if (now - gLast < 110) return;
    gLast = now;
    gFrame = (gFrame + 1) % 3;
    gtx.clearRect(0, 0, grain.width, grain.height);
    const tile = gTiles[gFrame];
    for (let y = 0; y < grain.height; y += 224)
      for (let x = 0; x < grain.width; x += 224)
        gtx.drawImage(tile, x, y);
  }

  /* ================= canvas helpers ================= */
  function setupCanvas(cv) {
    // SP: フレーム素材(540px幅)より高精細に描いても意味がないのでDPRを1.5で頭打ちにして描画コストを下げる
    const dpr = Math.min(devicePixelRatio || 1, isMobile() ? 1.5 : 2);
    // バッキングはCSSボックス実寸から取る。実機iOSは URLバーの出入りで
    // innerHeight と CSSの100vhがズレるため、vw/vh基準だと縦に引き伸ばされる
    // (メガネが伸びる・リングが楕円になる)
    const r = cv.getBoundingClientRect();
    cv.width = Math.round((r.width || vw) * dpr);
    cv.height = Math.round((r.height || vh) * dpr);
  }
  /* ================= design line-up (one-at-a-time showcase) ================= */
  // packshots: front leads, then the four side angles (lineup-<shape>-<color>-<angle>.jpg)
  const LU_ANGLES = ['front', 'side1', 'side2', 'side3', 'side4'];
  const luShots = (shape, color) => LU_ANGLES.map(a => `${window.TG_ASSET_BASE || 'assets/'}tg-lineup-${shape}-${color}-${a}.jpg`);
  const LU_FRAMES = [
    { id: 'boston', name: 'BOSTON',
      desc: '表情をやわらげる、ボストン<br />丸みが親しみやすさを添える、クラシックな形。<br />マットな質感が、全体の印象をさりげなく引き締めます。',
      photos: { black: luShots('boston', 'black'), demi: luShots('boston', 'demi') } },
    { id: 'square', name: 'SQUARE',
      desc: '日常に馴染む、スクエア<br />性別を問わず使いやすいスタンダードな形。<br />肌馴染みの良いカラーで自然に上品な印象になります。',
      photos: { black: luShots('square', 'black'), demi: luShots('square', 'demi') } },
    { id: 'wellington', name: 'WELLINGTON',
      desc: 'かけるほどに馴染む、ウェリントン<br />知的で誠実な印象を与える、王道の形。<br />顔立ちを選ばず、オンにもオフにも寄り添います。',
      photos: { black: luShots('wellington', 'black'), demi: luShots('wellington', 'demi') } }
  ];
  const luLayers = [$('#lu-a'), $('#lu-b')];
  const luTitle = $('#lu-title'), luDesc = $('#lu-desc');
  const luThPrev = $('#lu-th-prev'), luThNext = $('#lu-th-next');
  const luTypes = $$('.lu-type'), luSws = $$('.lu-sw');
  let luF = 1, luC = 'black', luP = 0, luAct = 0;

  const luPhotos = () => LU_FRAMES[luF].photos[luC];
  function luSet(imgEl, src) {
    imgEl.src = src;
  }
  function luMeta() {
    const f = LU_FRAMES[luF];
    const cName = luC === 'demi' ? 'DEMI' : 'BLACK';
    luTitle.textContent = f.name + ' / ' + cName;
    luDesc.innerHTML = f.desc;
    luLayers[luAct].alt = f.name + ' — ' + cName;
    luTypes.forEach(b => b.classList.toggle('on', b.dataset.frame === f.id));
    luSws.forEach(b => b.classList.toggle('on', b.dataset.color === luC));
  }
  // side thumbs preview what ‹ / › will show; they slide along with the direction
  function luThumbs(dir) {
    const ph = luPhotos(), n = ph.length;
    [[luThPrev, ph[(luP - 1 + n) % n]], [luThNext, ph[(luP + 1) % n]]].forEach(([el, src]) => {
      luSet(el, src);
      el.style.transition = 'none';
      el.style.transform = `translateX(${(dir || 0) * -34}%)`;
      el.style.opacity = 0;
      void el.offsetWidth;
      el.style.transition = '';
      el.style.transform = 'none';
      el.style.opacity = '';
    });
  }
  // dir ±1: photo slides through (new one grows in from the thumb side); dir 0: scale-dip crossfade
  function luSwapMain(src, dir) {
    const cur = luLayers[luAct], nxt = luLayers[1 - luAct];
    luSet(nxt, src);
    nxt.style.transition = 'none';
    nxt.style.transform = dir ? `translateX(${dir * 46}%) scale(.45)` : 'scale(.9)';
    nxt.style.opacity = 0;
    void nxt.offsetWidth; // flush so the entry position lands before animating
    nxt.style.transition = '';
    nxt.style.transform = 'none';
    nxt.style.opacity = 1;
    cur.style.transform = dir ? `translateX(${-dir * 46}%) scale(.45)` : 'scale(.9)';
    cur.style.opacity = 0;
    luAct = 1 - luAct;
  }
  // arrows / thumbs: other photos of the SAME product
  function luGoPhoto(dir) {
    const ph = luPhotos();
    luP = (luP + dir + ph.length) % ph.length;
    luSwapMain(ph[luP], dir);
    luThumbs(dir);
    luMeta();
  }
  // buttons only: type / color switches, always restarting at the lead photo
  function luGoVariant(nf, nc) {
    luF = nf; luC = nc; luP = 0;
    luSwapMain(luPhotos()[0], 0);
    luThumbs(0);
    luMeta();
  }
  if (luLayers[0]) {
    luTypes.forEach(b => b.addEventListener('click', () => {
      const i = LU_FRAMES.findIndex(x => x.id === b.dataset.frame);
      if (i !== luF) luGoVariant(i, luC);
    }));
    luSws.forEach(b => b.addEventListener('click', () => {
      if (b.dataset.color !== luC) luGoVariant(luF, b.dataset.color);
    }));
    $('#lu-arr-prev').addEventListener('click', () => luGoPhoto(-1));
    $('#lu-arr-next').addEventListener('click', () => luGoPhoto(1));
    luThPrev.addEventListener('click', () => luGoPhoto(-1));
    luThNext.addEventListener('click', () => luGoPhoto(1));
    luSet(luLayers[0], luPhotos()[0]);
    luThumbs(0);
    luMeta();
  }

  /* ================= tech movies (01 / 02) : autoplay whenever on screen ================= */
  const tkMovieEls = $$('.tk-movie video');
  const tkTryPlay = v => { if (v.paused) v.play().catch(() => {}); };
  const tkOnScreen = v => { const r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight; };
  const ioMov = new IntersectionObserver(entries => {
    if (!isMobile()) return; // PC : the pinned scrub drives play/pause
    entries.forEach(en => {
      const v = en.target;
      if (en.isIntersecting) tkTryPlay(v);
      else if (!v.paused && innerHeight > 0 && !tkOnScreen(v)) {
        // double-check with live geometry : throttled/hidden tabs can report stale non-intersection
        v.pause();
        if (!v.muted) { v.muted = true; ftSound.textContent = 'Sound on'; }
      }
    });
  }, { threshold: 0.15 });
  tkMovieEls.forEach(v => {
    v.muted = true;
    v.preload = 'auto';
    ioMov.observe(v);
    // if the file finishes loading while already on screen, start it
    v.addEventListener('canplay', () => { if (isMobile() && tkOnScreen(v)) tkTryPlay(v); });
  });
  // low-power mode fallback : the first touch counts as a gesture, retry then
  addEventListener('touchstart', () => {
    if (isMobile()) tkMovieEls.forEach(v => { if (tkOnScreen(v)) tkTryPlay(v); });
  }, { passive: true });

  /* ================= evidence videos : buffer 2 viewports early, play when scrolled in ================= */
  const eviVids = $$('.tk-vid video');
  const ioEviLoad = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      en.target.preload = 'auto';
      ioEviLoad.unobserve(en.target);
    });
  }, { rootMargin: '200% 0px' });
  const ioEvi = new IntersectionObserver(entries => {
    entries.forEach(en => {
      const v = en.target;
      if (en.isIntersecting) tkTryPlay(v);
      else if (!v.paused && innerHeight > 0 && !tkOnScreen(v)) v.pause();
    });
  }, { threshold: 0.15 });
  eviVids.forEach(v => {
    ioEviLoad.observe(v);
    ioEvi.observe(v);
    v.addEventListener('canplay', () => { if (tkOnScreen(v)) tkTryPlay(v); });
  });

  /* ================= FAQ accordion ================= */
  $$('.faq-item .fq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const on = btn.closest('.faq-item').classList.toggle('on');
      btn.setAttribute('aria-expanded', on);
    });
  });

  /* ================= story scene (concept chapters) ================= */
  const storySec = $('#scene-story');
  const storyCv = $('#story-canvas'), storyCtx = storyCv.getContext('2d');
  const storyScrim = $('#story-scrim'), storyNoise = $('#story-noise');
  const stPct = $('#st-pct'), stStrip = $('#st-strip');
  const chnav = $$('#story-chnav .cn');
  const stBlocks = $$('.st-block', storySec).map(b => ({
    el: b,
    a: +b.dataset.a,
    z: +b.dataset.b,
    hold: b.dataset.hold === '1',
    els: $$('.st-el', b).map((el, i, arr) => ({ el, s: 0.04 + i * Math.min(0.11, 0.44 / Math.max(arr.length - 1, 1)), d: 0.14 }))
  }));

  const NW_JA = ['通知', 'メール', '広告', '予定', '視線', '雑音', '速報', '既読', '会議', '渋滞', '人混み', '締切', 'アラーム', '着信', 'ニュース', '残業', 'スクロール', '群衆', '情報', '評価'];
  const NW_EN = ['NOISE', 'FEED', 'ALERT', 'PING', 'ADS', 'DM', 'NEWS', 'SNS', 'BUZZ', 'SPAM'];
  (function buildStoryNoise() {
    const words = [];
    for (let i = 0; i < 26; i++) words.push({ t: NW_JA[i % NW_JA.length], en: false });
    for (let i = 0; i < 10; i++) words.push({ t: NW_EN[i % NW_EN.length], en: true });
    words.forEach(w => {
      const s = document.createElement('span');
      s.className = 'nw' + (w.en ? ' en' : '');
      s.textContent = w.t;
      const size = 11 + Math.random() * 30;
      s.style.fontSize = size + 'px';
      s.style.left = (Math.random() * 96) + '%';
      s.style.top = (Math.random() * 94) + '%';
      s.style.setProperty('--blur', (Math.random() * 5 + (size > 28 ? 2 : 0.5)).toFixed(1) + 'px');
      s.style.setProperty('--op', (0.14 + Math.random() * 0.42).toFixed(2));
      s.style.setProperty('--tx', ((Math.random() - .5) * 130).toFixed(0) + 'px');
      s.style.setProperty('--ty', ((Math.random() - .5) * 110).toFixed(0) + 'px');
      s.style.setProperty('--r1', ((Math.random() - .5) * 8).toFixed(1) + 'deg');
      s.style.setProperty('--r2', ((Math.random() - .5) * 8).toFixed(1) + 'deg');
      s.style.setProperty('--dur', (5 + Math.random() * 9).toFixed(1) + 's');
      s.style.animationDelay = (-Math.random() * 10).toFixed(1) + 's';
      storyNoise.appendChild(s);
    });
    for (let i = 0; i < 46; i++) stStrip.appendChild(document.createElement('b'));
  })();

  // distance from the first tick to the last, so the needle can sweep the whole strip
  let stSpanPx = 0;
  const stSpan = () => stSpanPx || (stSpanPx = stStrip.lastElementChild.offsetLeft);

  function nearestFrame(i) {
    i = clamp(Math.round(i), 0, FRAME_N - 1);
    if (storyFrames[i]) return storyFrames[i];
    for (let d = 1; d < FRAME_N; d++) {
      if (i - d >= 0 && storyFrames[i - d]) return storyFrames[i - d];
      if (i + d < FRAME_N && storyFrames[i + d]) return storyFrames[i + d];
    }
    return null;
  }

  function drawCover(ctx, cv, img, alpha) {
    if (!img || !img.naturalWidth) return;
    const s = Math.max(cv.width / img.naturalWidth, cv.height / img.naturalHeight);
    const dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    ctx.globalAlpha = alpha == null ? 1 : alpha;
    ctx.drawImage(img, (cv.width - dw) / 2, (cv.height - dh) / 2, dw, dh);
    ctx.globalAlpha = 1;
  }

  function storyTick() {
    const rect = storySec.getBoundingClientRect();
    if (rect.bottom < -40 || rect.top > vh + 40 || rect.height <= vh) return;
    const p = clamp(-rect.top / (rect.height - vh), 0, 1);

    // frame scrub : stays noisy until the circular reveal begins (mid chapter 02)
    const CIRC_A = 0.58, CIRC_B = 0.80;
    const cp = clamp((p - CIRC_A) / (CIRC_B - CIRC_A), 0, 1);
    storyCtx.fillStyle = 'rgb(241,241,239)';
    storyCtx.fillRect(0, 0, storyCv.width, storyCv.height);
    const baseF = cp <= 0 ? (p / CIRC_A) * 46 : 46 + cp * 8;
    const fi = Math.floor(baseF), fr = baseF - fi;
    const A = nearestFrame(fi), B = nearestFrame(fi + 1);
    drawCover(storyCtx, storyCv, A, 1);
    if (B && B !== A && fr > 0.001) drawCover(storyCtx, storyCv, B, fr);

    // circular clear reveal with glowing rim
    if (cp > 0) {
      const cvw = storyCv.width, cvh = storyCv.height;
      const ccx = cvw / 2, ccy = cvh / 2;
      const ce = easeIO(cp);
      const R = Math.max(ce * (Math.hypot(cvw, cvh) / 2 + 80), 0.001);

      storyCtx.save();
      storyCtx.beginPath();
      storyCtx.arc(ccx, ccy, R, 0, Math.PI * 2);
      storyCtx.clip();
      drawCover(storyCtx, storyCv, nearestFrame(FRAME_N - 1), 1);
      storyCtx.restore();

      if (cp < 1) {
        // radiant ring : white core fading to a warm accent halo
        const rw = Math.max(cvw, cvh) * 0.10;
        const g = storyCtx.createRadialGradient(ccx, ccy, Math.max(R - rw, 0), ccx, ccy, R + rw);
        g.addColorStop(0, 'rgba(255,255,255,0)');
        g.addColorStop(0.42, 'rgba(255,255,255,.85)');
        g.addColorStop(0.56, 'rgba(255,246,240,.5)');
        g.addColorStop(0.74, 'rgba(255,61,0,.13)');
        g.addColorStop(1, 'rgba(255,61,0,0)');
        storyCtx.fillStyle = g;
        storyCtx.fillRect(0, 0, cvw, cvh);

        // crisp luminous edge
        storyCtx.save();
        storyCtx.strokeStyle = 'rgba(255,255,255,.95)';
        storyCtx.lineWidth = Math.max(1.2, Math.max(cvw, cvh) * 0.0016);
        storyCtx.shadowColor = 'rgba(255,255,255,1)';
        storyCtx.shadowBlur = 42;
        storyCtx.beginPath();
        storyCtx.arc(ccx, ccy, R, 0, Math.PI * 2);
        storyCtx.stroke();
        storyCtx.restore();
      }
    }

    // dip the scrim while the ring travels so the glow reads through
    storyScrim.style.opacity = ((1 - p * 0.15) * (1 - 0.55 * Math.sin(Math.PI * cp))).toFixed(3);
    storyNoise.style.opacity = Math.pow(clamp(1 - p * 1.15, 0, 1), 1.3).toFixed(3);

    // chapter blocks : line-by-line reveal
    let active = -1;
    stBlocks.forEach((blk, bi) => {
      if (bi > 0 && p >= blk.a) active = bi - 1;
      const t = (p - blk.a) / (blk.z - blk.a);
      const live = t >= 0 && t <= 1.04;
      blk.el.classList.toggle('live', live);
      if (!live) return;
      const out = blk.hold ? 0 : easeIO(clamp((t - 0.86) / 0.14, 0, 1));
      for (const it of blk.els) {
        const e = easeO(clamp((t - it.s) / it.d, 0, 1));
        it.el.style.opacity = (e * (1 - out)).toFixed(3);
        it.el.style.transform = `translateY(${((1 - e) * 34 - out * 40).toFixed(1)}px)`;
        it.el.style.filter = `blur(${((1 - e) * 7 + out * 6).toFixed(2)}px)`;
      }
    });
    chnav.forEach((c, i) => c.classList.toggle('on', i === active));

    stPct.textContent = String(Math.round(p * 100)).padStart(3, '0');
    // 0% rests the needle on the first tick, 100% on the last
    stStrip.style.transform = `translateX(${(-p * stSpan()).toFixed(1)}px)`;
  }

  /* ================= technology scene (pinned beats) ================= */
  const techSec = $('#technology');
  const techCv = $('#tech-canvas');
  const ringsGL = techCv.getContext('webgl2', { alpha: true, premultipliedAlpha: false, preserveDrawingBuffer: true })
               || techCv.getContext('webgl', { alpha: true, premultipliedAlpha: false, preserveDrawingBuffer: true });
  const techCtx = ringsGL ? null : techCv.getContext('2d');
  const tkWatermark = $('.tk-watermark', techSec);
  const tkBlocks = $$('.st-block', techSec).map(b => ({
    el: b,
    a: +b.dataset.a,
    z: +b.dataset.b,
    hold: b.dataset.hold === '1',
    movie: $('.tk-movie video', b),
    els: $$('.st-el', b).map((el, i, arr) => ({ el, s: 0.04 + i * Math.min(0.11, 0.44 / Math.max(arr.length - 1, 1)), d: 0.14 }))
  }));

  // matrix rain : 3/6/9 glyphs falling on a 2D layer behind the rings.
  // Glyphs are pre-rendered sprites (white core + glow) so the per-frame cost
  // is drawImage only — no shadowBlur inside the loop.
  const mxCv = $('#tech-matrix');
  const mxCtx = mxCv.getContext('2d');
  const MX = { glyphs: ['3', '6', '9'], font: 12, colGap: 2.2, rowGap: 1.35, stepMs: 70, glow: 7, maxA: 0.72 };
  let mxCols = [], mxBody = [], mxHead = [], mxCell = 0, mxRow = 0, mxLast = -1e9, mxStill = false;
  function mxSprite(ch, dpr, head) {
    const fs = Math.round(MX.font * dpr), pad = Math.ceil(MX.glow * dpr * 2.4);
    const c = document.createElement('canvas');
    c.width = c.height = fs + pad * 2;
    const x = c.getContext('2d');
    x.font = `500 ${fs}px 'IBM Plex Mono', monospace`;
    x.textAlign = 'center'; x.textBaseline = 'middle';
    x.shadowColor = 'rgba(255,255,255,.95)';
    x.shadowBlur = MX.glow * dpr;
    x.fillStyle = head ? '#ffffff' : 'rgba(244,244,242,.9)';
    x.fillText(ch, c.width / 2, c.height / 2);
    if (head) { x.shadowBlur = MX.glow * dpr * 2.2; x.fillText(ch, c.width / 2, c.height / 2); }
    return c;
  }
  function mxNewCol(rows) {
    return {
      y: -Math.floor(Math.random() * rows * 1.4),
      speed: 0.7 + Math.random() * 1.5,           // rows per step
      trail: 7 + Math.floor(Math.random() * 12),
      seed: Math.floor(Math.random() * 3),
      acc: 0
    };
  }
  function mxResize() {
    const dpr = Math.min(devicePixelRatio || 1, 2);
    mxCell = Math.round(MX.font * MX.colGap * dpr);
    mxRow = Math.round(MX.font * MX.rowGap * dpr);
    mxBody = MX.glyphs.map(g => mxSprite(g, dpr, false));
    mxHead = MX.glyphs.map(g => mxSprite(g, dpr, true));
    const rows = Math.ceil(mxCv.height / mxRow);
    mxCols = Array.from({ length: Math.ceil(mxCv.width / mxCell) + 1 }, () => mxNewCol(rows));
    // scatter ahead so the section doesn't open on an empty sky
    mxCols.forEach(c => { c.y += Math.floor(Math.random() * rows); });
    mxLast = -1e9; mxStill = false;
  }
  function drawMatrix(now) {
    if (reduced) { if (mxStill) return; mxStill = true; now = 1200; }
    else if (now - mxLast < MX.stepMs) return;
    mxLast = now;
    const W = mxCv.width, H = mxCv.height;
    const rows = Math.ceil(H / mxRow) + 1;
    const salt = (now / 640) | 0;                  // slow glyph mutation
    mxCtx.clearRect(0, 0, W, H);
    for (let i = 0; i < mxCols.length; i++) {
      const c = mxCols[i];
      c.acc += c.speed;
      const adv = c.acc | 0; c.acc -= adv; c.y += adv;
      if (c.y - c.trail > rows) Object.assign(c, mxNewCol(rows), { y: -Math.floor(Math.random() * 6) });
      const x = i * mxCell + mxCell / 2;
      for (let k = 0; k < c.trail; k++) {
        const ry = c.y - k;
        if (ry < 0 || ry >= rows) continue;
        const g = (i * 7 + ry * 13 + c.seed + salt) % 3;
        const sp = k === 0 ? mxHead[g] : mxBody[g];
        mxCtx.globalAlpha = k === 0 ? Math.min(1, MX.maxA + 0.35) : (1 - k / c.trail) * MX.maxA;
        mxCtx.drawImage(sp, x - sp.width / 2, ry * mxRow - sp.height / 2);
      }
    }
    mxCtx.globalAlpha = 1;
  }

  const ftMovie = $('#ft-movie'), ftSound = $('#ft-sound');
  ftSound.addEventListener('click', () => {
    ftMovie.muted = !ftMovie.muted;
    if (!ftMovie.muted) ftMovie.play().catch(() => {});
    ftSound.textContent = ftMovie.muted ? 'Sound on' : 'Sound off';
  });

  // MagicRings (React Bits) ported to raw WebGL — concentric rings with angular
  // cutaway, cycle fade and film grain. Falls back to drawCrystalline without GL.
  const RING = {
    color: [1.0, 1.0, 1.0],           // #ffffff — glow on the dark stage
    colorTwo: [0.976, 0.451, 0.086],  // #F97316
    ringCount: 6, speed: 1, attenuation: 10, lineThickness: 2,
    baseRadius: 0.35, radiusStep: 0.1, scaleRate: 0.1, opacity: 1,
    noiseAmount: 0.07, ringGap: 1.2, fadeIn: 0.7, fadeOut: 0.5
  };
  let ringsProg = null, ringsU = null;
  if (ringsGL) {
    const gl = ringsGL;
    const vs = 'attribute vec2 aPos; void main(){ gl_Position = vec4(aPos, 0.0, 1.0); }';
    const fs = `
precision highp float;
uniform float uTime, uAttenuation, uLineThickness, uBaseRadius, uRadiusStep, uScaleRate;
uniform float uOpacity, uNoiseAmount, uRingGap, uFadeIn, uFadeOut;
uniform vec2 uResolution;
uniform vec3 uColor, uColorTwo;
uniform int uRingCount;
const float HP = 1.5707963;
const float CYCLE = 3.45;
float fade(float t) {
  return t < uFadeIn ? smoothstep(0.0, uFadeIn, t) : 1.0 - smoothstep(uFadeOut, CYCLE - 0.2, t);
}
float ring(vec2 p, float ri, float cut, float t0, float px) {
  float t = mod(uTime + t0, CYCLE);
  float r = ri + t / CYCLE * uScaleRate;
  float d = abs(length(p) - r);
  float a = atan(abs(p.y), abs(p.x)) / HP;
  float th = max(1.0 - a, 0.5) * px * uLineThickness;
  float h = (1.0 - smoothstep(th, th * 1.5, d)) + 1.0;
  d += pow(cut * a * 0.25, 3.0) * r;   // weak angular cutaway so the ripple reaches the top/bottom edge
  return h * exp(-uAttenuation * d) * fade(t);
}
void main() {
  float px = 1.0 / max(uResolution.x, uResolution.y);   // normalize to the long side so the rings fill the screen in both orientations
  vec2 p = (gl_FragCoord.xy - 0.5 * uResolution.xy) * px;
  vec3 c = vec3(0.0);
  float rcf = max(float(uRingCount) - 1.0, 1.0);
  for (int i = 0; i < 10; i++) {
    if (i >= uRingCount) break;
    float fi = float(i);
    vec3 rc = mix(uColor, uColorTwo, fi / rcf);
    float v = ring(p, uBaseRadius + fi * uRadiusStep, pow(uRingGap, fi), i == 0 ? 0.0 : 2.95 * fi, px);
    c = mix(c, rc, vec3(v));
  }
  float n = fract(sin(dot(gl_FragCoord.xy + uTime * 100.0, vec2(12.9898, 78.233))) * 43758.5453);
  c += (n - 0.5) * uNoiseAmount;
  gl_FragColor = vec4(c, max(c.r, max(c.g, c.b)) * uOpacity);
}`;
    const mk = (type, src) => {
      const sh = gl.createShader(type);
      gl.shaderSource(sh, src); gl.compileShader(sh);
      return gl.getShaderParameter(sh, gl.COMPILE_STATUS) ? sh : null;
    };
    const v = mk(gl.VERTEX_SHADER, vs), f = mk(gl.FRAGMENT_SHADER, fs);
    if (v && f) {
      const prog = gl.createProgram();
      gl.attachShader(prog, v); gl.attachShader(prog, f); gl.linkProgram(prog);
      if (gl.getProgramParameter(prog, gl.LINK_STATUS)) {
        gl.useProgram(prog);
        const buf = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buf);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
        const aPos = gl.getAttribLocation(prog, 'aPos');
        gl.enableVertexAttribArray(aPos);
        gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);
        const u = n => gl.getUniformLocation(prog, n);
        ringsU = { uTime: u('uTime'), uResolution: u('uResolution') };
        gl.uniform1f(u('uAttenuation'), RING.attenuation);
        gl.uniform1f(u('uLineThickness'), RING.lineThickness);
        gl.uniform1f(u('uBaseRadius'), RING.baseRadius);
        gl.uniform1f(u('uRadiusStep'), RING.radiusStep);
        gl.uniform1f(u('uScaleRate'), RING.scaleRate);
        gl.uniform1f(u('uOpacity'), RING.opacity);
        gl.uniform1f(u('uNoiseAmount'), RING.noiseAmount);
        gl.uniform1f(u('uRingGap'), RING.ringGap);
        gl.uniform1f(u('uFadeIn'), RING.fadeIn);
        gl.uniform1f(u('uFadeOut'), RING.fadeOut);
        gl.uniform3fv(u('uColor'), RING.color);
        gl.uniform3fv(u('uColorTwo'), RING.colorTwo);
        gl.uniform1i(u('uRingCount'), RING.ringCount);
        ringsProg = prog;
      }
    }
  }
  function drawRings(now) {
    const gl = ringsGL, W = techCv.width, H = techCv.height;
    gl.viewport(0, 0, W, H);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniform1f(ringsU.uTime, (reduced ? 1200 : now) * 0.001 * RING.speed);
    gl.uniform2f(ringsU.uResolution, W, H);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
  }

  // crystalline refraction : dot grid displaced by an expanding circular wave
  // (fallback when WebGL is unavailable)
  function drawCrystalline(now) {
    const W = techCv.width, H = techCv.height;
    techCtx.clearRect(0, 0, W, H);
    const dpr = Math.min(devicePixelRatio || 1, 2);        // canvas is in device px — keep dot size in CSS px
    const ccx = W / 2, ccy = H / 2;
    const maxR = Math.hypot(ccx, ccy) * 1.15;
    const t = reduced ? maxR * 0.45 : (now * 0.12 * dpr) % maxR;   // circular front, calm pace
    const waveWidth = Math.max(W, H) * 0.13;
    const dispMax = Math.max(W, H) * 0.022;
    const gap = Math.max(26 * dpr, W / 46);

    for (let gy = gap / 2; gy < H + gap; gy += gap) {
      for (let gx = gap / 2; gx < W + gap; gx += gap) {
        const dist = Math.hypot(gx - ccx, gy - ccy);
        const distToWave = Math.abs(dist - t);
        let disp = 0, k = 0;
        if (distToWave < waveWidth / 2) {
          const u = 1 - distToWave / (waveWidth / 2);    // 1 at the wave front
          // main pulse + damped secondary ripple = bounce with overshoot
          const springy = Math.sin(u * Math.PI) + Math.sin(u * Math.PI * 3) * 0.4 * u;
          disp = springy * dispMax;
          k = clamp(Math.abs(springy) / 0.92, 0, 1);   // 0.92 ≈ peak of the springy curve
        }
        const ang = Math.atan2(gy - ccy, gx - ccx);
        const dx = Math.cos(ang) * disp, dy = Math.sin(ang) * disp;
        const size = (1.3 + k * 2.2) * dpr;
        if (k > 0.96) {
          techCtx.fillStyle = `rgba(249,115,22,${(0.3 + 0.3 * k).toFixed(3)})`;
        } else {
          techCtx.fillStyle = `rgba(244,244,242,${(0.14 + 0.3 * k).toFixed(3)})`;
        }
        techCtx.beginPath();
        techCtx.arc(gx + dx, gy + dy, size, 0, Math.PI * 2);
        techCtx.fill();
      }
    }
  }

  let tkCleared = false;
  function techTick(now) {
    const rect = techSec.getBoundingClientRect();
    const offscreen = rect.bottom < -40 || rect.top > vh + 40;

    if (isMobile()) {
      // normal scroll : blocks flow over the sticky 100svh canvas; no scrub styles
      if (!tkCleared) {
        tkCleared = true;
        tkBlocks.forEach(blk => {
          blk.el.style.transform = '';
          blk.els.forEach(it => {
            it.el.style.opacity = ''; it.el.style.transform = ''; it.el.style.filter = '';
          });
        });
      }
      if (offscreen) return;
      drawMatrix(now);
      if (ringsProg) drawRings(now); else if (techCtx) drawCrystalline(now);
      tkBlocks.forEach(blk => {
        const r = blk.el.getBoundingClientRect();
        // intro / 01 / 02 : scroll-linked fade in/out around the viewport center
        if (blk.el.classList.contains('tk-split') || blk.el.classList.contains('tk-intro')) {
          // the intro is sticky inside .tk-intro-pin: while pinned its center sits at the
          // viewport center (c≈0), so this same formula holds it at full opacity for free
          const c = (r.top + r.height / 2 - vh / 2) / vh;
          const o = clamp(1 - (Math.abs(c) - 0.16) / 0.3, 0, 1);
          blk.el.style.opacity = easeIO(o).toFixed(3);
          if (blk.el.classList.contains('tk-intro')) {
            // scale follows progress through the pin wrapper: grows while the text holds center
            const wr = blk.el.parentElement.getBoundingClientRect();
            const pr = clamp(-wr.top / (wr.height - vh), 0, 1);
            blk.el.style.transform = `scale(${(1 + pr * 0.1).toFixed(4)})`;
          }
        } else if (blk.el.classList.contains('tk-evi-block')) {
          // evidence is taller than a viewport : fade on the edges, fully visible while reading
          const en = clamp((vh - r.top) / (vh * 0.45), 0, 1);
          const ex = clamp(r.bottom / (vh * 0.45), 0, 1);
          blk.el.style.opacity = easeIO(Math.min(en, ex)).toFixed(3);
        }
      });
      // movies : play/pause is owned by ioMov (IntersectionObserver on the video elements)
      return;
    }
    if (tkCleared) {
      tkCleared = false;
      tkBlocks.forEach(blk => { blk.el.style.opacity = ''; blk.el.style.transform = ''; });
    }

    if (offscreen || rect.height <= vh) return;
    const p = clamp(-rect.top / (rect.height - vh), 0, 1);

    drawMatrix(now);
    if (ringsProg) drawRings(now); else if (techCtx) drawCrystalline(now);
    tkWatermark.style.transform = `translate(-50%, -50%) translateX(${((0.5 - p) * 16).toFixed(2)}vw)`;

    tkBlocks.forEach(blk => {
      const t = (p - blk.a) / (blk.z - blk.a);
      const live = t >= 0 && t <= 1.04;
      blk.el.classList.toggle('live', live);
      if (blk.movie) {
        if (live && blk.movie.paused) blk.movie.play().catch(() => {});
        else if (!live && !blk.movie.paused) {
          blk.movie.pause();
          if (!blk.movie.muted) { blk.movie.muted = true; ftSound.textContent = 'Sound on'; }
        }
      }
      if (!live) return;
      // intro only: the whole lockup swells gently as its scrub segment progresses
      if (blk.el.classList.contains('tk-intro')) {
        blk.el.style.transform = `scale(${(1 + clamp(t, 0, 1) * 0.1).toFixed(4)})`;
      }
      const out = blk.hold ? 0 : easeIO(clamp((t - 0.86) / 0.14, 0, 1));
      for (const it of blk.els) {
        const e = easeO(clamp((t - it.s) / it.d, 0, 1));
        it.el.style.opacity = (e * (1 - out)).toFixed(3);
        it.el.style.transform = `translateY(${((1 - e) * 34 - out * 40).toFixed(1)}px)`;
        it.el.style.filter = `blur(${((1 - e) * 7 + out * 6).toFixed(2)}px)`;
      }
    });
  }

  /* ================= life scene (horizontal) ================= */
  const lifeSec = $('#scene-life');
  const lifeTrack = $('#life-track'), lifeFill = $('#life-fill');
  const lifeImgs = $$('.life-panel img', lifeTrack);

  // dwell-and-slide : each panel holds full-screen, then eases to the next
  const LIFE_HOLD = 1, LIFE_SLIDE = 1.6;
  function lifeMap(p, n) {
    const total = n * LIFE_HOLD + (n - 1) * LIFE_SLIDE;
    let acc = 0;
    for (let i = 0; i < n; i++) {
      if (p <= (acc + LIFE_HOLD) / total) return i;
      acc += LIFE_HOLD;
      if (i < n - 1) {
        if (p <= (acc + LIFE_SLIDE) / total) {
          return i + easeIO((p - acc / total) / (LIFE_SLIDE / total));
        }
        acc += LIFE_SLIDE;
      }
    }
    return n - 1;
  }

  function lifeTick() {
    const rect = lifeSec.getBoundingClientRect();
    if (rect.bottom < -40 || rect.top > vh + 40 || rect.height <= vh) return;
    const p = clamp(-rect.top / (rect.height - vh), 0, 1);
    const n = lifeImgs.length;
    const pos = lifeMap(p, n);
    const mob = isMobile();
    if (mob) {
      // vertical dwell-and-slide : same pacing as PC, panels slide upward
      const y = -(pos / (n - 1)) * (lifeTrack.scrollHeight - lifeTrack.parentElement.clientHeight);
      lifeTrack.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0)`;
    } else {
      const x = -(pos / (n - 1)) * (lifeTrack.scrollWidth - vw);
      lifeTrack.style.transform = `translate3d(${x.toFixed(1)}px, 0, 0)`;
    }

    const total = n * LIFE_HOLD + (n - 1) * LIFE_SLIDE;
    lifeImgs.forEach((im, i) => {
      // slow zoom across each panel's visible window (arrival slide -> departure slide)
      const start = i === 0 ? 0 : (i * LIFE_HOLD + (i - 1) * LIFE_SLIDE) / total;
      const end = i === n - 1 ? 1 : ((i + 1) * (LIFE_HOLD + LIFE_SLIDE)) / total;
      const z = clamp((p - start) / (end - start), 0, 1);
      const sc = 1 + 0.055 * z;
      const drift = ((pos - i) * -3).toFixed(2);
      im.style.transform = (mob ? `translateY(${drift}%)` : `translateX(${drift}%)`) + ` scale(${sc.toFixed(4)})`;
    });
    if (lifeFill) lifeFill.style.transform = `scaleX(${p})`;
  }

  /* ================= product details (05) — pinned horizontal slider ================= */
  const psSec = $('#product'), psTrack = $('#ps-track');
  const psCards = psTrack ? $$('.ss-card', psTrack) : [];
  const psImgs = psTrack ? $$('.ss-card img', psTrack) : [];
  const psDots = $$('.ps-prog button');
  // click a dot -> glide to the middle of that card's hold window
  psDots.forEach((d, i) => d.addEventListener('click', () => {
    const n = psCards.length;
    if (!n || isMobile()) return;
    const total = n * LIFE_HOLD + (n - 1) * LIFE_SLIDE;
    const pTarget = (i * (LIFE_HOLD + LIFE_SLIDE) + LIFE_HOLD / 2) / total;
    const y = psSec.offsetTop + pTarget * (psSec.offsetHeight - vh);
    lenis ? lenis.scrollTo(y) : scrollTo(0, y);
  }));
  function psTick() {
    if (!psCards.length) return;
    if (isMobile()) {
      psTrack.style.transform = 'none';
      // SPは「写真の上・キャプション下」の積み上げレイアウト:
      // ズーム(scale)すると画像がキャプション側へ数pxはみ出すので掛けない
      psImgs.forEach(im => { if (im.style.transform) im.style.transform = ''; });
      return;
    }
    const rect = psSec.getBoundingClientRect();
    if (rect.bottom < -40 || rect.top > vh + 40 || rect.height <= vh) return;
    const p = clamp(-rect.top / (rect.height - vh), 0, 1);
    const n = psCards.length;
    const pos = lifeMap(p, n); // same dwell-and-slide pacing as the life scene
    const i0 = Math.min(Math.floor(pos), n - 1), i1 = Math.min(i0 + 1, n - 1), f = pos - i0;
    // slide right-to-left so the active card lands where card 1 started;
    // capped so the last stop puts the final card at the right inset (no dead space)
    const lastCard = psCards[n - 1];
    const maxX = Math.max(0, lastCard.offsetLeft + lastCard.offsetWidth
      + parseFloat(getComputedStyle(psTrack).paddingRight) - vw);
    const off = i => Math.min(psCards[i].offsetLeft - psCards[0].offsetLeft, maxX);
    const x = -(off(i0) + (off(i1) - off(i0)) * f);
    psTrack.style.transform = `translate3d(${x.toFixed(1)}px, 0, 0)`;
    const total = n * LIFE_HOLD + (n - 1) * LIFE_SLIDE;
    psImgs.forEach((im, i) => {
      // gentle zoom across the card's time on stage (arrival -> departure)
      const start = i === 0 ? 0 : (i * LIFE_HOLD + (i - 1) * LIFE_SLIDE) / total;
      const end = i === n - 1 ? 1 : ((i + 1) * (LIFE_HOLD + LIFE_SLIDE)) / total;
      const z = clamp((p - start) / (end - start), 0, 1);
      im.style.transform = `scale(${(1 + 0.06 * z).toFixed(4)})`;
    });
    const act = Math.round(pos);
    psDots.forEach((d, i) => d.classList.toggle('on', i === act));
  }

  /* ================= reveals (IO) ================= */
  // threshold は 0 にする: 割合しきい値(旧0.18)だと背の高い要素(Dailyのグリッド等)は
  // 「全高の18% = 数百px」スクロールするまで発火せず、セクションが白いまま残る
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
  $$('.rv, #spec-fig, .ss-card').forEach(el => io.observe(el));

  // 写真のカーテン(.rv-clip)は「画面に入る30%手前」で先に開き始める:
  // スクロールが届いた時にはもう写真が見えている。中の写真のデコード完了は待つ
  // (白箱→後から写真がパッと出るのを防ぐ)が、2.5sで必ず開く保険つき
  function makeClipIO(opts) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        obs.unobserve(en.target);
        const el = en.target;
        const img = el.querySelector('img');
        let opened = false;
        const open = () => { if (!opened) { opened = true; el.classList.add('in'); } };
        if (img && img.decode && !(img.complete && img.naturalWidth)) {
          img.decode().then(open, open);
          setTimeout(open, 2500);
        } else open();
      });
    }, opts);
    return obs;
  }
  const ioClip = makeClipIO({ threshold: 0, rootMargin: '0px 0px 30% 0px' });
  // Dailyの2枚目以降だけは先読みせず、実際に画面に入って12%見えてから開く
  // (全部先読みすると「スクロールしたらもう全部出ている」で演出が消えるため)
  const ioClipLate = makeClipIO({ threshold: 0.12, rootMargin: '0px' });
  $$('.rv-clip').forEach(el =>
    (el.matches('#daily .scn:not(:first-child) .scn-fig') ? ioClipLate : ioClip).observe(el));

  const ioCount = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      ioCount.unobserve(en.target);
      const el = en.target, raw = el.dataset.count, target = +raw, dec = (raw.split('.')[1] || '').length, t0 = performance.now();
      (function step(now) {
        const k = easeO(clamp((now - t0) / 1300, 0, 1));
        el.textContent = (target * k).toFixed(dec);
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    });
  }, { threshold: 0.4 });
  $$('[data-count]').forEach(el => ioCount.observe(el));

  /* ================= parallax images ================= */
  const plxItems = $$('[data-plx]').map(el => ({ el, img: $('img', el), k: +el.dataset.plx }));
  function plxTick() {
    for (const it of plxItems) {
      const r = it.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue;
      const c = (r.top + r.height / 2 - vh / 2) / vh;
      it.img.style.transform = `scale(${1 + it.k * 2.2}) translateY(${(-c * it.k * 100).toFixed(2)}px)`;
    }
  }

  /* ================= progress bar ================= */
  const bar = $('#bar');
  /* nav theme: handled in CSS via mix-blend-mode: difference (always inverts vs backdrop) */

  /* ================= master loop ================= */
  let lastVW = 0, lastVH = 0;
  const coarsePointer = matchMedia('(pointer: coarse)').matches;
  function loop(now) {
    // viewport is 0×0 while the tab is hidden/prerendered — skip ticking but keep the loop alive
    vw = innerWidth; vh = innerHeight;
    if (!vw || !vh) { requestAnimationFrame(loop); return; }
    if (vw !== lastVW || vh !== lastVH) {
      // on touch devices the URL bar shows/hides during scroll and only innerHeight
      // moves — rebuilding then re-scatters the 369 rain mid-scroll, so skip it
      const rebuild = vw !== lastVW || !coarsePointer || !lastVH;
      lastVW = vw; lastVH = vh;
      if (rebuild) {
        setupCanvas(storyCv);
        setupCanvas(techCv);
        setupCanvas(mxCv);
        mxResize();
        grain.width = vw; grain.height = vh;
      }
    }

    const doc = document.documentElement;
    const max = doc.scrollHeight - vh;
    bar.style.transform = `scaleX(${max > 0 ? clamp(scrollY / max, 0, 1) : 0})`;

    storyTick();
    techTick(now);
    lifeTick();
    psTick();
    plxTick();
    drawGrain(now);
    requestAnimationFrame(loop);
  }

  requestAnimationFrame(loop);
})();

/* ================= logo loop (CSS-animation marquee — compositor-driven, jank-free) ================= */
(() => {
  document.querySelectorAll('.ll-loop').forEach(root => {
    const track = root.querySelector('.ll-track');
    const baseList = root.querySelector('.ll-list');
    const SPEED = Math.abs(parseFloat(root.dataset.speed || '55')); /* px/s */
    const items = [...baseList.children].map(li => li.cloneNode(true));

    /* fill the base list to at least the viewport width, add one clone list,
       then let a translateX(-50%) keyframe loop it on the compositor thread */
    function build() {
      track.querySelectorAll('.ll-list').forEach((l, i) => { if (i > 0) l.remove(); });
      baseList.replaceChildren(...items.map(li => li.cloneNode(true)));
      let guard = 0;
      while (baseList.offsetWidth < root.offsetWidth && guard++ < 12) {
        items.forEach(li => baseList.appendChild(li.cloneNode(true)));
      }
      const clone = baseList.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      track.style.setProperty('--ll-dur', (baseList.offsetWidth / SPEED).toFixed(2) + 's');
    }

    if (window.ResizeObserver) {
      let lastW = 0;
      new ResizeObserver(() => {
        if (root.offsetWidth !== lastW) { lastW = root.offsetWidth; build(); }
      }).observe(root);
    } else {
      window.addEventListener('resize', build);
    }
    let pending = [...baseList.querySelectorAll('img')].filter(img => !img.complete).length;
    baseList.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', () => { if (--pending === 0) build(); }, { once: true });
    });
    build();
  });
})();

/* ================= brand ProfileCards — tilt engine (vanilla port of React Bits) ================= */
(() => {
  const wraps = document.querySelectorAll('.pc-card-wrapper');
  if (!wraps.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const clamp = (v, a = 0, b = 100) => Math.min(Math.max(v, a), b);
  const adjust = (v, a, b, c, d) => c + (d - c) * (v - a) / (b - a);
  const TAU = .14;
  const AUTO = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  wraps.forEach((wrap, idx) => {
    const shell = wrap.querySelector('.pc-card-shell');
    let cx = 0, cy = 0, tx = 0, ty = 0, raf = null, last = 0;

    function setVars() {
      const w = shell.clientWidth || 1, h = shell.clientHeight || 1;
      const px = clamp(100 / w * cx), py = clamp(100 / h * cy);
      wrap.style.setProperty('--pointer-x', px + '%');
      wrap.style.setProperty('--pointer-y', py + '%');
      wrap.style.setProperty('--background-x', adjust(px, 0, 100, 35, 65) + '%');
      wrap.style.setProperty('--background-y', adjust(py, 0, 100, 35, 65) + '%');
      wrap.style.setProperty('--pointer-from-center', clamp(Math.hypot(py - 50, px - 50) / 50, 0, 1));
      wrap.style.setProperty('--pointer-from-top', py / 100);
      wrap.style.setProperty('--pointer-from-left', px / 100);
      wrap.style.setProperty('--rotate-x', (-(px - 50) / 20).toFixed(3) + 'deg');
      wrap.style.setProperty('--rotate-y', ((py - 50) / 17).toFixed(3) + 'deg');
    }
    function step(ts) {
      raf = null;
      const dt = last ? (ts - last) / 1000 : .016;
      last = ts;
      const k = 1 - Math.exp(-dt / TAU);
      cx += (tx - cx) * k; cy += (ty - cy) * k;
      setVars();
      if (Math.abs(tx - cx) > .05 || Math.abs(ty - cy) > .05) raf = requestAnimationFrame(step);
      else { last = 0; shell.classList.contains('leaving') && shell.classList.remove('active', 'leaving'); }
    }
    const start = () => { if (raf === null) { last = 0; raf = requestAnimationFrame(step); } };
    const off = e => { const r = shell.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };

    if (AUTO) {
      /* touch devices can't hover — the hologram is always on, and the
         virtual pointer drifts on a slow orbit so the light moves by itself */
      cx = shell.clientWidth / 2; cy = shell.clientHeight / 2;
      setVars();
      shell.classList.add('active'); wrap.classList.add('active');
      let autoRaf = null, t0 = 0;
      const drift = ts => {
        if (!t0) t0 = ts;
        const t = (ts - t0) / 1000;
        cx = shell.clientWidth * (.5 + .40 * Math.sin(t * .28 + idx * 2.1));
        cy = shell.clientHeight * (.5 + .36 * Math.sin(t * .43 + 1.2 + idx * 2.1));
        setVars();
        autoRaf = requestAnimationFrame(drift);
      };
      /* only the rAF loop pauses off-screen (perf) — the hologram itself stays visible */
      new IntersectionObserver(es => es.forEach(en => {
        if (en.isIntersecting) {
          if (autoRaf === null) autoRaf = requestAnimationFrame(drift);
        } else if (autoRaf !== null) { cancelAnimationFrame(autoRaf); autoRaf = null; }
      }), { threshold: 0 }).observe(wrap);
      return;
    }

    /* freeze the tilt while the pointer is over the bottom bar,
       so the 詳細 button stays put and stays clickable */
    const overUI = e => e.target.closest && e.target.closest('.pc-user-info');
    shell.addEventListener('pointerenter', e => {
      shell.classList.add('active'); shell.classList.remove('leaving');
      wrap.classList.add('active');
      if (!overUI(e)) { [tx, ty] = off(e); start(); }
    });
    shell.addEventListener('pointermove', e => { if (!overUI(e)) { [tx, ty] = off(e); start(); } });
    shell.addEventListener('pointerleave', () => {
      tx = shell.clientWidth / 2; ty = shell.clientHeight / 2;
      shell.classList.add('leaving');
      wrap.classList.remove('active');
      start();
    });

    cx = tx = shell.clientWidth / 2; cy = ty = shell.clientHeight / 2;
    setVars();
  });
})();

/* ================= brand cards — specular rim on the 詳細 bar
   (vanilla WebGL2 port of React Bits <SpecularButton/>, no deps) ================= */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
  const bars = document.querySelectorAll('.pc-user-info');
  if (!bars.length) return;

  const PAD = 20, PROXIMITY = 250, SPEED = .35, INTENSITY = 1;
  const RADIUS = 18, THICKNESS = 1.2;
  const SHINE_SIZE = 10 * Math.PI / 180, SHINE_FADE = 40 * Math.PI / 180;
  const LINE_RGB = [1, 1, 1], BASE_RGB = [.42, .42, .42];

  const VERT = '#version 300 es\nin vec2 position;void main(){gl_Position=vec4(position,0.,1.);}';
  const FRAG = `#version 300 es
precision highp float;
uniform vec2 uCenter;uniform vec2 uHalfSize;uniform float uRadius;uniform float uAngle;uniform float uPx;
uniform vec3 uLineColor;uniform vec3 uBaseColor;uniform float uIntensity;
uniform float uShineSize;uniform float uShineFade;uniform float uThickness;uniform float uBaseWidth;
out vec4 fragColor;
float sdRoundedRect(vec2 p,vec2 b,float r){vec2 q=abs(p)-b+r;return length(max(q,0.))+min(max(q.x,q.y),0.)-r;}
float gaussianLine(float d,float sigma){float x=d/(sigma+1e-6);float k=mix(1.,1.6,smoothstep(0.,1.5,x));return exp(-k*x*x);}
void main(){
  vec2 p=gl_FragCoord.xy-uCenter;
  float d=sdRoundedRect(p,uHalfSize,uRadius);
  vec2 L=vec2(cos(uAngle),sin(uAngle));
  /* base stroke scales with intensity here (unlike upstream) — the bar
     already has its own CSS border, so the rim fades in as a whole */
  float base=(1.-smoothstep(0.,uBaseWidth,abs(d)))*.45*min(uIntensity,1.);
  vec2 nEll=normalize(p/(uHalfSize*uHalfSize)+1e-6);
  float phi=acos(clamp(abs(dot(nEll,L)),0.,1.));
  float rim=1.-smoothstep(uShineSize-uShineFade,uShineSize+uShineFade+1e-4,phi);
  float line=gaussianLine(d,uThickness);
  float edgeClamp=1.-smoothstep(.5*uPx,3.*uPx,abs(d));
  float hi=line*rim*edgeClamp*uIntensity;
  vec3 col=uBaseColor*base+uLineColor*hi;
  fragColor=vec4(col,clamp(base+hi,0.,1.));
}`;

  bars.forEach(bar => {
    const dpr = window.devicePixelRatio || 1;
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl2', { alpha: true, premultipliedAlpha: true, antialias: true });
    if (!gl) return;
    const sh = (t, src) => { const s = gl.createShader(t); gl.shaderSource(s, src); gl.compileShader(s); return s; };
    const prog = gl.createProgram();
    gl.attachShader(prog, sh(gl.VERTEX_SHADER, VERT));
    gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FRAG));
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
    gl.useProgram(prog);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    const pos = gl.getAttribLocation(prog, 'position');
    gl.enableVertexAttribArray(pos);
    gl.vertexAttribPointer(pos, 2, gl.FLOAT, false, 0, 0);
    const u = {};
    ['uCenter','uHalfSize','uRadius','uAngle','uPx','uLineColor','uBaseColor','uIntensity',
     'uShineSize','uShineFade','uThickness','uBaseWidth'].forEach(n => u[n] = gl.getUniformLocation(prog, n));
    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.uniform1f(u.uPx, dpr); gl.uniform1f(u.uBaseWidth, dpr);
    gl.uniform3fv(u.uLineColor, LINE_RGB); gl.uniform3fv(u.uBaseColor, BASE_RGB);
    gl.uniform1f(u.uShineSize, SHINE_SIZE); gl.uniform1f(u.uShineFade, SHINE_FADE);
    gl.uniform1f(u.uThickness, THICKNESS * dpr);

    const fx = document.createElement('div');
    fx.className = 'pc-sb-fx'; fx.setAttribute('aria-hidden', 'true');
    fx.appendChild(canvas);
    bar.prepend(fx);

    let W = 1, H = 1;
    const resize = () => {
      W = bar.offsetWidth; H = bar.offsetHeight;
      canvas.width = Math.max(1, Math.round((W + PAD * 2) * dpr));
      canvas.height = Math.max(1, Math.round((H + PAD * 2) * dpr));
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.uniform2f(u.uCenter, (PAD + W / 2) * dpr, (PAD + H / 2) * dpr);
      gl.uniform2f(u.uHalfSize, W / 2 * dpr, H / 2 * dpr);
      gl.uniform1f(u.uRadius, Math.min(RADIUS, Math.min(W, H) / 2) * dpr);
    };
    new ResizeObserver(resize).observe(bar);
    resize();

    /* light angle steers toward the pointer; shine fades in with proximity */
    let pointerAngle = null, proximityT = 0;
    window.addEventListener('pointermove', e => {
      const r = bar.getBoundingClientRect();
      const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      const dx = Math.max(r.left - e.clientX, 0, e.clientX - r.right);
      const dy = Math.max(r.top - e.clientY, 0, e.clientY - r.bottom);
      const dist = Math.hypot(dx, dy);
      if (dist === 0) {
        const nx = (e.clientX - cx) / (r.width / 2), ny = (cy - e.clientY) / (r.height / 2);
        pointerAngle = Math.atan2(2 / r.height, -2 / r.width) + nx * .3 + ny * .15;
      } else {
        pointerAngle = Math.atan2(cy - e.clientY, e.clientX - cx);
      }
      const t = Math.max(0, 1 - dist / PROXIMITY);
      proximityT = t * t * (3 - 2 * t);
    }, { passive: true });

    let angle = 2.4, idleAngle = 2.4, bright = 0, last = performance.now(), drawn = false;
    const update = now => {
      requestAnimationFrame(update);
      const dt = Math.min((now - last) / 1000, .05); last = now;
      idleAngle += SPEED * dt;
      const target = pointerAngle != null ? pointerAngle : idleAngle;
      const diff = ((target - angle + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
      angle += diff * (1 - Math.exp(-dt * 7));
      bright += (proximityT - bright) * (1 - Math.exp(-dt * 8));
      if (bright < .002 && proximityT === 0) {
        if (drawn) { gl.clear(gl.COLOR_BUFFER_BIT); drawn = false; }
        return;
      }
      gl.uniform1f(u.uAngle, angle);
      gl.uniform1f(u.uIntensity, INTENSITY * bright);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      drawn = true;
    };
    requestAnimationFrame(update);
  });
})();

/* ================= brand detail modals ================= */
(() => {
  const openers = document.querySelectorAll('[data-modal]');
  if (!openers.length) return;
  let lastFocus = null, hideTimer = null;

  function open(m) {
    clearTimeout(hideTimer);
    m.hidden = false;
    void m.offsetWidth; /* flush styles so the transition still plays — no rAF (frozen in some embedded views) */
    m.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    m.querySelectorAll('video').forEach(v => { if (v.paused) v.play().catch(() => {}); });
    m.querySelector('.bdm-panel').focus({ preventScroll: true });
  }
  function close(m) {
    m.classList.remove('on');
    document.documentElement.style.overflow = '';
    hideTimer = setTimeout(() => { m.hidden = true; }, 500);
    m.querySelectorAll('video').forEach(v => v.pause());
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  openers.forEach(btn => btn.addEventListener('click', () => {
    lastFocus = btn;
    const m = document.getElementById(btn.dataset.modal);
    if (m) open(m);
  }));
  document.querySelectorAll('.bdm').forEach(m => {
    m.addEventListener('click', e => { if (e.target.closest('[data-close]')) close(m); });
    const panel = m.querySelector('.bdm-panel');
    panel.addEventListener('scroll', () => {
      panel.classList.toggle('is-scrolled', panel.scrollTop > 8);
    }, { passive: true });
  });
  window.addEventListener('keydown', e => {
    if (e.key === 'Escape') { const m = document.querySelector('.bdm.on'); if (m) close(m); }
  });
})();
